
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-partners",
      function () {
        return require("private-next-pages/all-partners.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-partners"])
      });
    }
  